import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  icon,
  moreTo,
  moreLabel = "查看更多",
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
      <div className="flex items-center gap-3">
        <span className="w-1 h-7 md:h-8 rounded-full bg-primary-500"></span>
        <div>
          <h2 className="text-lg md:text-2xl font-heading font-bold text-foreground-950 flex items-center gap-2">
            {icon && <i className={`${icon} text-primary-500 text-xl md:text-2xl`}></i>}
            {title}
          </h2>
          {subtitle && <p className="text-xs md:text-sm text-foreground-500 mt-0.5">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="hidden sm:flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      )}
    </div>
  );
}